import React from 'react';

import { type LeaderboardDividerProps, LeaderboardDividerVariant, type LeaderboardProps } from './types';

import { StyledDivider, StyledLeaderboard } from './styles';

export function Leaderboard({ children }: LeaderboardProps) {
    return <StyledLeaderboard>{children}</StyledLeaderboard>;
}

export function LeaderboardDivider({ variant = LeaderboardDividerVariant.Neutral }: LeaderboardDividerProps) {
    return <StyledDivider $variant={variant} />;
}
